(function () {
function $8713978b2328d32b$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $cd5a47cf8ef6d766$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $c3b10a83b523f372$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$79e617b1955a2616)(arr);
}


function $09c9f293d010c0e1$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$79e617b1955a2616)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$79e617b1955a2616)(o, minLen);
}


function $227c6742e0ff6f82$export$1b5e630bc3aea29f(arr) {
    return (0, $c50969dc1df61e8b$export$7e0947b5ad3404e2)(arr) || (0, $09c9f293d010c0e1$export$1eb58a6e75231000)(arr) || (0, $d4f69c5c6c4654b1$export$a5be06335b3a083c)(arr) || (0, $38c2d4931cb7a7c4$export$e6f3c4780d19eb2b)();
}


"use strict";
var $3d28d7f1aac198f5$var$GRID_SIZE = 4;
var $3d28d7f1aac198f5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Game() {
        (0, $8713978b2328d32b$export$2996f80ef42b8419)(this, Game);
        (0, $cd5a47cf8ef6d766$export$1e71eb4bef00f6b0)(this, "createConfetti", function() {
            var confettiContainer = document.querySelector(".confetti-container");
            var confetti = document.createElement("div");
            confetti.classList.add("confetti");
            confetti.style.backgroundColor = "hsl(".concat(Math.random() * 360, ", 100%, 50%)");
            confetti.style.left = "".concat(Math.random() * 100, "vw");
            confetti.style.animationDelay = "".concat(Math.random(), "s");
            confetti.style.animationDuration = "".concat(Math.random() * 2 + 3, "s");
            confettiContainer.appendChild(confetti);
            setTimeout(function() {
                confetti.remove();
            }, 5000);
        });
        this.board = this.getState();
        this.score = 0;
        this.gameActive = false;
        this.cells = document.querySelectorAll(".field-cell");
        this.messageWin = document.querySelector(".message-win");
        this.messageLose = document.querySelector(".message-lose");
        this.assignDataAttributes();
    }
    (0, $4fc75ccb937ab1df$export$d60067ff2358eee8)(Game, [
        {
            key: "assignDataAttributes",
            value: function assignDataAttributes() {
                this.cells.forEach(function(cell, index) {
                    var row = Math.floor(index / $3d28d7f1aac198f5$var$GRID_SIZE);
                    var col = index % $3d28d7f1aac198f5$var$GRID_SIZE;
                    cell.dataset.row = row;
                    cell.dataset.col = col;
                });
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                if (!this.gameActive) return;
                var changed = false;
                for(var col = 0; col < $3d28d7f1aac198f5$var$GRID_SIZE; col++)if (this.moveColumnUp(col)) changed = true;
                if (changed) {
                    this.getRandomTile();
                    this.addCell();
                }
                this.checkGameStatus();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                if (!this.gameActive) return;
                var changed = false;
                for(var col = 0; col < $3d28d7f1aac198f5$var$GRID_SIZE; col++)if (this.moveColumnDown(col)) changed = true;
                if (changed) {
                    this.getRandomTile();
                    this.addCell();
                }
                this.checkGameStatus();
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                if (!this.gameActive) return;
                var changed = false;
                for(var row = 0; row < $3d28d7f1aac198f5$var$GRID_SIZE; row++)if (this.moveColumnLeft(row)) changed = true;
                if (changed) {
                    this.getRandomTile();
                    this.addCell();
                }
                this.checkGameStatus();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                if (!this.gameActive) return;
                var changed = false;
                for(var row = 0; row < $3d28d7f1aac198f5$var$GRID_SIZE; row++)if (this.moveColumnRight(row)) changed = true;
                if (changed) {
                    this.getRandomTile();
                    this.addCell();
                }
                this.checkGameStatus();
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.board.flat().reduce(function(acc, value) {
                    return acc + value;
                }, 0);
            }
        },
        {
            key: "getState",
            value: function getState() {
                return (0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)(Array($3d28d7f1aac198f5$var$GRID_SIZE)).map(function() {
                    return Array($3d28d7f1aac198f5$var$GRID_SIZE).fill(0);
                });
            }
        },
        {
            key: "getRandomTile",
            value: function getRandomTile() {
                var emptyTiles = [];
                for(var row = 0; row < $3d28d7f1aac198f5$var$GRID_SIZE; row++){
                    for(var col = 0; col < $3d28d7f1aac198f5$var$GRID_SIZE; col++)if (this.board[row][col] === 0) emptyTiles.push({
                        row: row,
                        col: col
                    });
                }
                if (emptyTiles.length) {
                    var _emptyTiles_Math_floor = emptyTiles[Math.floor(Math.random() * emptyTiles.length)], row1 = _emptyTiles_Math_floor.row, col1 = _emptyTiles_Math_floor.col;
                    this.board[row1][col1] = Math.random() < 0.9 ? 2 : 4;
                    this.animateNewTile(row1, col1);
                    return {
                        row: row1,
                        col: col1,
                        value: this.board[row1][col1]
                    };
                }
                return null;
            }
        },
        {
            key: "checkWin",
            value: function checkWin() {
                return this.board.flat().includes(2048);
            }
        },
        {
            key: "checkLose",
            value: function checkLose() {
                for(var row = 0; row < $3d28d7f1aac198f5$var$GRID_SIZE; row++)for(var col = 0; col < $3d28d7f1aac198f5$var$GRID_SIZE; col++){
                    if (this.board[row][col] === 0) return false;
                    var checkCol = col < $3d28d7f1aac198f5$var$GRID_SIZE - 1 && this.board[row][col] === this.board[row][col + 1];
                    var checkRow = row < $3d28d7f1aac198f5$var$GRID_SIZE - 1 && this.board[row][col] === this.board[row + 1][col];
                    if (checkCol || checkRow) return false;
                }
                return true;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                if (this.checkWin()) return "win";
                if (this.checkLose()) return "lose";
                return "playing";
            }
        },
        {
            key: "checkGameStatus",
            value: function checkGameStatus() {
                var gameStatus = this.getStatus();
                if (gameStatus === "win") {
                    this.messageWin.classList.remove("hidden");
                    this.showWinMessage();
                    this.showConfetti();
                } else if (gameStatus === "lose") {
                    this.messageLose.classList.remove("hidden");
                    this.showGameOverMessage();
                }
            }
        },
        {
            key: "addCell",
            value: function addCell() {
                var _this = this;
                this.cells.forEach(function(cell, index) {
                    var row = Math.floor(index / $3d28d7f1aac198f5$var$GRID_SIZE);
                    var col = index % $3d28d7f1aac198f5$var$GRID_SIZE;
                    var value = _this.board[row][col];
                    var hasValue = value ? " field-cell--".concat(value) : "";
                    cell.className = "field-cell" + hasValue;
                    cell.textContent = value || "";
                    _this.animateAppear(row, col);
                });
            }
        },
        {
            key: "deleteCell",
            value: function deleteCell() {
                this.cells.forEach(function(cell) {
                    cell.className = "field-cell";
                    cell.textContent = "";
                });
            }
        },
        {
            key: "start",
            value: function start(element) {
                this.gameActive = true;
                this.score = 0;
                element.classList.replace("start", "restart");
                element.textContent = "Restart";
                this.getRandomTile();
                this.getRandomTile();
                this.addCell();
                this.assignDataAttributes();
            }
        },
        {
            key: "restart",
            value: function restart(element) {
                this.gameActive = false;
                this.score = 0;
                var hasHiddenLose = this.messageLose.classList.contains("hidden");
                var hasHiddenWin = this.messageWin.classList.contains("hidden");
                if (!hasHiddenLose) this.messageLose.classList.add("hidden");
                if (!hasHiddenWin) this.messageWin.classList.add("hidden");
                element.classList.replace("restart", "start");
                element.textContent = "Start";
                this.board = this.getState();
                this.deleteCell();
                this.assignDataAttributes();
            }
        },
        {
            key: "moveColumnUp",
            value: function moveColumnUp(col) {
                var changed = false;
                var compressedColumn = this.board.map(function(row) {
                    return row[col];
                }).filter(function(value) {
                    return value !== 0;
                });
                for(var i = 0; i < compressedColumn.length - 1; i++)if (compressedColumn[i] === compressedColumn[i + 1]) {
                    compressedColumn[i] *= 2;
                    compressedColumn.splice(i + 1, 1);
                    this.score += compressedColumn[i];
                    this.animateMerge(i, col);
                    changed = true;
                }
                while(compressedColumn.length < $3d28d7f1aac198f5$var$GRID_SIZE)compressedColumn.push(0);
                for(var row = 0; row < $3d28d7f1aac198f5$var$GRID_SIZE; row++){
                    if (this.board[row][col] !== compressedColumn[row]) changed = true;
                    this.board[row][col] = compressedColumn[row];
                    this.animateMove(row, col);
                }
                return changed;
            }
        },
        {
            key: "moveColumnDown",
            value: function moveColumnDown(col) {
                var changed = false;
                var compressedColumn = this.board.map(function(row) {
                    return row[col];
                }).filter(function(value) {
                    return value !== 0;
                });
                for(var i = compressedColumn.length - 1; i > 0; i--)if (compressedColumn[i] === compressedColumn[i - 1]) {
                    compressedColumn[i] *= 2;
                    compressedColumn.splice(i - 1, 1);
                    this.score += compressedColumn[i];
                    this.animateMerge(i, col);
                    changed = true;
                }
                while(compressedColumn.length < $3d28d7f1aac198f5$var$GRID_SIZE)compressedColumn.unshift(0);
                for(var row = 0; row < $3d28d7f1aac198f5$var$GRID_SIZE; row++){
                    if (this.board[row][col] !== compressedColumn[row]) changed = true;
                    this.board[row][col] = compressedColumn[row];
                    this.animateMove(row, col);
                }
                return changed;
            }
        },
        {
            key: "moveColumnLeft",
            value: function moveColumnLeft(row) {
                var changed = false;
                var compressedRow = this.board[row].filter(function(value) {
                    return value !== 0;
                });
                for(var i = 0; i < compressedRow.length - 1; i++)if (compressedRow[i] === compressedRow[i + 1]) {
                    compressedRow[i] *= 2;
                    compressedRow.splice(i + 1, 1);
                    this.score += compressedRow[i];
                    this.animateMerge(row, i);
                    changed = true;
                }
                while(compressedRow.length < $3d28d7f1aac198f5$var$GRID_SIZE)compressedRow.push(0);
                if (this.board[row].some(function(value, index) {
                    return value !== compressedRow[index];
                })) changed = true;
                this.board[row] = compressedRow;
                for(var col = 0; col < $3d28d7f1aac198f5$var$GRID_SIZE; col++)this.animateMove(row, col);
                return changed;
            }
        },
        {
            key: "moveColumnRight",
            value: function moveColumnRight(row) {
                var changed = false;
                var compressedRow = this.board[row].filter(function(value) {
                    return value !== 0;
                });
                for(var i = compressedRow.length - 1; i > 0; i--)if (compressedRow[i] === compressedRow[i - 1]) {
                    compressedRow[i] *= 2;
                    compressedRow.splice(i - 1, 1);
                    this.score += compressedRow[i];
                    this.animateMerge(row, i);
                    changed = true;
                }
                while(compressedRow.length < $3d28d7f1aac198f5$var$GRID_SIZE)compressedRow.unshift(0);
                if (this.board[row].some(function(value, index) {
                    return value !== compressedRow[index];
                })) changed = true;
                this.board[row] = compressedRow;
                for(var col = 0; col < $3d28d7f1aac198f5$var$GRID_SIZE; col++)this.animateMove(row, col);
                return changed;
            }
        },
        {
            key: "animateNewTile",
            value: function animateNewTile(row, col) {
                var cell = document.querySelector('.field-cell[data-row="'.concat(row, '"][data-col="').concat(col, '"]'));
                if (cell) {
                    cell.classList.add("field-cell--new");
                    setTimeout(function() {
                        cell.classList.remove("field-cell--new");
                    }, 300);
                }
            }
        },
        {
            key: "animateAppear",
            value: function animateAppear(row, col) {
                var cell = document.querySelector('.field-cell[data-row="'.concat(row, '"][data-col="').concat(col, '"]'));
                if (cell) {
                    cell.classList.add("field-cell--appear");
                    setTimeout(function() {
                        cell.classList.remove("field-cell--appear");
                    }, 200);
                }
            }
        },
        {
            key: "animateMerge",
            value: function animateMerge(row, col) {
                var cell = document.querySelector('.field-cell[data-row="'.concat(row, '"][data-col="').concat(col, '"]'));
                if (cell) {
                    cell.classList.add("field-cell--merge");
                    setTimeout(function() {
                        cell.classList.remove("field-cell--merge");
                    }, 300);
                }
            }
        },
        {
            key: "animateMove",
            value: function animateMove(row, col) {
                var cell = document.querySelector('.field-cell[data-row="'.concat(row, '"][data-col="').concat(col, '"]'));
                if (cell) {
                    cell.classList.add("field-cell--move");
                    setTimeout(function() {
                        cell.classList.remove("field-cell--move");
                    }, 300);
                }
            }
        },
        {
            key: "showGameOverMessage",
            value: function showGameOverMessage() {
                var gameOverOverlay = document.querySelector(".game-over-overlay");
                gameOverOverlay.classList.remove("hidden");
                setTimeout(function() {
                    gameOverOverlay.classList.add("show");
                }, 10);
                setTimeout(function() {
                    gameOverOverlay.classList.remove("show");
                    setTimeout(function() {
                        gameOverOverlay.classList.add("hidden");
                    }, 1000);
                }, 3000);
            }
        },
        {
            key: "showWinMessage",
            value: function showWinMessage() {
                var winOverlay = document.querySelector(".win-overlay");
                winOverlay.classList.remove("hidden");
                setTimeout(function() {
                    winOverlay.classList.add("show");
                }, 10);
                setTimeout(function() {
                    winOverlay.classList.remove("show");
                    setTimeout(function() {
                        winOverlay.classList.add("hidden");
                    }, 1000);
                }, 3000);
            }
        },
        {
            key: "showConfetti",
            value: function showConfetti() {
                for(var i = 0; i < 100; i++)this.createConfetti();
            }
        }
    ]);
    return Game;
}();


"use strict";
document.addEventListener("DOMContentLoaded", function() {
    var MESSAGE_RESTART = "Are you sure you want to start a new game? All progress will be lost.";
    var game = new (0, $3d28d7f1aac198f5$export$2e2bcd8739ae039)();
    var gameStart = document.querySelector(".button");
    var score = document.querySelector(".game-score");
    var messageStart = document.querySelector(".message-start");
    var checkStatus = function() {
        var hasStart = gameStart.classList.contains("start");
        if (hasStart) {
            game.start(gameStart);
            messageStart.classList.add("hidden");
        } else {
            if (confirm(MESSAGE_RESTART)) {
                game.restart(gameStart);
                game.start(gameStart);
            } else return;
        }
        setUpScore();
        setUpInputOnce();
    };
    var setUpInputOnce = function() {
        return window.addEventListener("keydown", handleInput, {
            once: true
        });
    };
    var setUpScore = function() {
        score.textContent = game.getScore();
    };
    var handleInput = function(event) {
        switch(event.key){
            case "ArrowUp":
                game.moveUp();
                break;
            case "ArrowDown":
                game.moveDown();
                break;
            case "ArrowLeft":
                game.moveLeft();
                break;
            case "ArrowRight":
                game.moveRight();
                break;
            default:
                setUpInputOnce();
                return;
        }
        setUpScore();
        setUpInputOnce();
    };
    setUpInputOnce();
    gameStart.addEventListener("click", checkStatus);
});

})();
//# sourceMappingURL=index.7420ddc3.js.map
